import { initializeApp } from 'firebase/app';
import { getDatabase, ref, push, set, get, onValue, update } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyD4e6X09r0QVdtKwvAu9Aka6TLrayOne00",
  authDomain: "dashy-tartra.firebaseapp.com",
  databaseURL: "https://dashy-tartra-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "dashy-tartra",
  storageBucket: "dashy-tartra.firebasestorage.app",
  messagingSenderId: "487944082875",
  appId: "1:487944082875:web:8c0a4b89ae34d5ac93e09e"
};

const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
export { ref, push, set, get, onValue, update };
export default app;
